<template>
  <div v-if="isPC" class="content-area">
    <div v-show="url === '-1'">
      <div class="carousel-wrapper">
        <Slide :picts="resources" />
      </div>
    </div>
    <div v-show="url !== '-1'">
      <div class="player-wrapper" v-if="isHtml">
        <iframe :src="url" frameborder="0"></iframe>
      </div>
      <div class="player-wrapper" v-show="!isHtml">
        <video class="video-js vjs-big-play-centered" id="video_live2" controls preload="auto" autoplay></video>
      </div>
    </div>
  </div>
  <div v-else class="m-content-area" id="m-content-area">
    <div v-show="url === '-1'">
      <div class="carousel-wrapper">
        <Slide :picts="resources" />
      </div>
    </div>
    <div v-show="url !== '-1'">
      <div class="player-wrapper" v-show="isHtml">
        <iframe :src="url" frameborder="0"></iframe>
      </div>
      <div class="player-wrapper" v-show="!isHtml">
        <video class="video-js vjs-big-play-centered" id="video_live2" controls preload="auto" autoplay></video>
      </div>
    </div>
  </div>
</template>

<script>
import Slide from '@/common/Slide'
export default {
  name: 'Live',
  components: { Slide },
  props: ['closeLive', 'videoUrl'],
  data () {
    return {
      url: '',
      player: null,
      resources: [],
      isHtml: false,
    }
  },
  mounted () {
    let self = this
    /* eslint-disable */
    // this.videoUrl = 'https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8'
    if (!this.videoUrl) {
      this.url = this.getTodayLive()
    } else {
      this.url = this.videoUrl
    }
    if (this.url !== '-1') {
      let media_type = ''
      if (this.url.indexOf('.m3u8') !== -1) {
        media_type = 'application/x-mpegURL'
        this.isHtml = false
      } else if (this.url.indexOf('.mp4') !== -1) {
        media_type = 'video/mp4'
        this.isHtml = false
      } else {
        this.isHtml = true
      }
      if (!this.isHtml) {
        this.player = videojs(document.getElementById('video_live2'))
        this.player.on('ready', function() {
          self.player.src({
            src: self.url,
            type: media_type
          })
        })
      }
    } else {
      let data = this.$allData[this.currentLang] || []
      for (let item of data) {
        if (item.showType === 'bigScreen') {
          this.resources = item.voiceInfos.filter((i) => {
            return i.useFor === 'bigscreen'
          }).map((i) => {
            return {
              url: i.filePath,
              type: 'video'
            }
          })
          break
        }
      }
    }
  },
  methods: {
    getTodayLive () {
      let data = this.$allData[this.currentLang] || []
      let d = window.__systime
      d = d.getFullYear() + this.nTos(d.getMonth() + 1) + this.nTos(d.getDate()) + this.nTos(d.getHours()) + this.nTos(d.getMinutes())
      let videoUrl = ''
      for (let i of data) {
        if (i.showType !== 'live') {continue}
        let min = '2022' + this.nTos(i.boothNo.split('月')[0]) + this.nTos(i.boothNo.split('月')[1].split('日')[0]) + i.boothNo.split('）')[1].split('-')[0].replace(':', '')
        let max = '2022' + this.nTos(i.boothNo.split('月')[0]) + this.nTos(i.boothNo.split('月')[1].split('日')[0]) + i.boothNo.split('）')[1].split('-')[1].replace(':', '')
        if (parseFloat(d) > parseFloat(min) && parseFloat(d) < parseFloat(max)) {
          videoUrl = i.videoInfos && i.videoInfos[0] ? i.videoInfos[0].filePath : ''
          break
        }
      }
      if (videoUrl === '') {
        videoUrl = '-1'
      }
      return videoUrl
    },
    docloseLive () {
      if (this.isHtml) {
        this.closeLive && this.closeLive()
        return
      }
      this.player.dispose()
      this.player = null
      this.$nextTick(() => {
        this.closeLive && this.closeLive()
      })
    },
    nTos (m) {return (parseInt(m, 10) < 10) ? '0' + String(parseInt(m, 10)) : String(parseInt(m, 10))}
  }
}
</script>

<style scoped>
  .content-area {
    width:100%;
    min-height: 100%;
    background-color: rgba(0,0,0,0.6);
    text-align: center;
  }
  .carousel-wrapper {
    margin: 0 auto;
    padding-top: 10rem;
    width: 80rem;
    height: 46rem;
  }
  .player-wrapper {
    margin: 0 auto;
    padding-top: 10rem;
    width: 80rem;
    height: 46rem;
  }
  #m-content-area {
    box-sizing: border-box !important;
  }
  .m-content-area {
    width: 100%;
    height: 100%;
    padding-left: 0;
    padding-right: 0;
    background-color: rgba(0,0,0,0.6);
  }
  .m-content-area .carousel-wrapper {
    padding: 50px 0 0 0;
    width: 100%;
    height: 100%;
    position: relative;
  }
  .m-content-area .player-wrapper {
    padding: 50px 0 0 0;
    width: 100%;
    height: 100%;
    position: relative;
  }
  .video-js {
    width: 100%;
    height: 100%;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
</style>